// src/design/forms/datepicker/calendar-carburettor/converter/look-up.ts
var e = {
	365: {
		year: 2e3,
		month_days: [
			0,
			30,
			32,
			31,
			32,
			31,
			30,
			30,
			30,
			29,
			30,
			29,
			31,
			365
		]
	},
	730: {
		year: 2001,
		month_days: [
			0,
			31,
			31,
			32,
			31,
			31,
			31,
			30,
			29,
			30,
			29,
			30,
			30,
			365
		]
	},
	1095: {
		year: 2002,
		month_days: [
			0,
			31,
			31,
			32,
			32,
			31,
			30,
			30,
			29,
			30,
			29,
			30,
			30,
			365
		]
	},
	1461: {
		year: 2003,
		month_days: [
			0,
			31,
			32,
			31,
			32,
			31,
			30,
			30,
			30,
			29,
			29,
			30,
			31,
			366
		]
	},
	1826: {
		year: 2004,
		month_days: [
			0,
			30,
			32,
			31,
			32,
			31,
			30,
			30,
			30,
			29,
			30,
			29,
			31,
			365
		]
	},
	2191: {
		year: 2005,
		month_days: [
			0,
			31,
			31,
			32,
			31,
			31,
			31,
			30,
			29,
			30,
			29,
			30,
			30,
			365
		]
	},
	2556: {
		year: 2006,
		month_days: [
			0,
			31,
			31,
			32,
			32,
			31,
			30,
			30,
			29,
			30,
			29,
			30,
			30,
			365
		]
	},
	2922: {
		year: 2007,
		month_days: [
			0,
			31,
			32,
			31,
			32,
			31,
			30,
			30,
			30,
			29,
			29,
			30,
			31,
			366
		]
	},
	3287: {
		year: 2008,
		month_days: [
			0,
			31,
			31,
			31,
			32,
			31,
			31,
			29,
			30,
			30,
			29,
			29,
			31,
			365
		]
	},
	3652: {
		year: 2009,
		month_days: [
			0,
			31,
			31,
			32,
			31,
			31,
			31,
			30,
			29,
			30,
			29,
			30,
			30,
			365
		]
	},
	4017: {
		year: 2010,
		month_days: [
			0,
			31,
			31,
			32,
			32,
			31,
			30,
			30,
			29,
			30,
			29,
			30,
			30,
			365
		]
	},
	4383: {
		year: 2011,
		month_days: [
			0,
			31,
			32,
			31,
			32,
			31,
			30,
			30,
			30,
			29,
			29,
			30,
			31,
			366
		]
	},
	4748: {
		year: 2012,
		month_days: [
			0,
			31,
			31,
			31,
			32,
			31,
			31,
			29,
			30,
			30,
			29,
			30,
			30,
			365
		]
	},
	5113: {
		year: 2013,
		month_days: [
			0,
			31,
			31,
			32,
			31,
			31,
			31,
			30,
			29,
			30,
			29,
			30,
			30,
			365
		]
	},
	5478: {
		year: 2014,
		month_days: [
			0,
			31,
			31,
			32,
			32,
			31,
			30,
			30,
			29,
			30,
			29,
			30,
			30,
			365
		]
	},
	5844: {
		year: 2015,
		month_days: [
			0,
			31,
			32,
			31,
			32,
			31,
			30,
			30,
			30,
			29,
			29,
			30,
			31,
			366
		]
	},
	6209: {
		year: 2016,
		month_days: [
			0,
			31,
			31,
			31,
			32,
			31,
			31,
			29,
			30,
			30,
			29,
			30,
			30,
			365
		]
	},
	6574: {
		year: 2017,
		month_days: [
			0,
			31,
			31,
			32,
			31,
			31,
			31,
			30,
			29,
			30,
			29,
			30,
			30,
			365
		]
	},
	6939: {
		year: 2018,
		month_days: [
			0,
			31,
			32,
			31,
			32,
			31,
			30,
			30,
			29,
			30,
			29,
			30,
			30,
			365
		]
	},
	7305: {
		year: 2019,
		month_days: [
			0,
			31,
			32,
			31,
			32,
			31,
			30,
			30,
			30,
			29,
			30,
			29,
			31,
			366
		]
	},
	7670: {
		year: 2020,
		month_days: [
			0,
			31,
			31,
			31,
			32,
			31,
			31,
			30,
			29,
			30,
			29,
			30,
			30,
			365
		]
	},
	8035: {
		year: 2021,
		month_days: [
			0,
			31,
			31,
			32,
			31,
			31,
			31,
			30,
			29,
			30,
			29,
			30,
			30,
			365
		]
	},
	8400: {
		year: 2022,
		month_days: [
			0,
			31,
			32,
			31,
			32,
			31,
			30,
			30,
			30,
			29,
			29,
			30,
			30,
			365
		]
	},
	8766: {
		year: 2023,
		month_days: [
			0,
			31,
			32,
			31,
			32,
			31,
			30,
			30,
			30,
			29,
			30,
			29,
			31,
			366
		]
	},
	9131: {
		year: 2024,
		month_days: [
			0,
			31,
			31,
			31,
			32,
			31,
			31,
			30,
			29,
			30,
			29,
			30,
			30,
			365
		]
	},
	9496: {
		year: 2025,
		month_days: [
			0,
			31,
			31,
			32,
			31,
			31,
			31,
			30,
			29,
			30,
			29,
			30,
			30,
			365
		]
	},
	9862: {
		year: 2026,
		month_days: [
			0,
			31,
			32,
			31,
			32,
			31,
			30,
			30,
			30,
			29,
			29,
			30,
			31,
			366
		]
	},
	10227: {
		year: 2027,
		month_days: [
			0,
			30,
			32,
			31,
			32,
			31,
			30,
			30,
			30,
			29,
			30,
			29,
			31,
			365
		]
	},
	10592: {
		year: 2028,
		month_days: [
			0,
			31,
			31,
			32,
			31,
			31,
			31,
			30,
			29,
			30,
			29,
			30,
			30,
			365
		]
	},
	10957: {
		year: 2029,
		month_days: [
			0,
			31,
			31,
			32,
			31,
			32,
			30,
			30,
			29,
			30,
			29,
			30,
			30,
			365
		]
	},
	11323: {
		year: 2030,
		month_days: [
			0,
			31,
			32,
			31,
			32,
			31,
			30,
			30,
			30,
			29,
			29,
			30,
			31,
			366
		]
	},
	11688: {
		year: 2031,
		month_days: [
			0,
			30,
			32,
			31,
			32,
			31,
			30,
			30,
			30,
			29,
			30,
			29,
			31,
			365
		]
	},
	12053: {
		year: 2032,
		month_days: [
			0,
			31,
			31,
			32,
			31,
			31,
			31,
			30,
			29,
			30,
			29,
			30,
			30,
			365
		]
	},
	12418: {
		year: 2033,
		month_days: [
			0,
			31,
			31,
			32,
			32,
			31,
			30,
			30,
			29,
			30,
			29,
			30,
			30,
			365
		]
	},
	12784: {
		year: 2034,
		month_days: [
			0,
			31,
			32,
			31,
			32,
			31,
			30,
			30,
			30,
			29,
			29,
			30,
			31,
			366
		]
	},
	13149: {
		year: 2035,
		month_days: [
			0,
			30,
			32,
			31,
			32,
			31,
			31,
			29,
			30,
			30,
			29,
			29,
			31,
			365
		]
	},
	13514: {
		year: 2036,
		month_days: [
			0,
			31,
			31,
			32,
			31,
			31,
			31,
			30,
			29,
			30,
			29,
			30,
			30,
			365
		]
	},
	13879: {
		year: 2037,
		month_days: [
			0,
			31,
			31,
			32,
			32,
			31,
			30,
			30,
			29,
			30,
			29,
			30,
			30,
			365
		]
	},
	14245: {
		year: 2038,
		month_days: [
			0,
			31,
			32,
			31,
			32,
			31,
			30,
			30,
			30,
			29,
			29,
			30,
			31,
			366
		]
	},
	14610: {
		year: 2039,
		month_days: [
			0,
			31,
			31,
			31,
			32,
			31,
			31,
			29,
			30,
			30,
			29,
			30,
			30,
			365
		]
	},
	14975: {
		year: 2040,
		month_days: [
			0,
			31,
			31,
			32,
			31,
			31,
			31,
			30,
			29,
			30,
			29,
			30,
			30,
			365
		]
	},
	15340: {
		year: 2041,
		month_days: [
			0,
			31,
			31,
			32,
			32,
			31,
			30,
			30,
			29,
			30,
			29,
			30,
			30,
			365
		]
	},
	15706: {
		year: 2042,
		month_days: [
			0,
			31,
			32,
			31,
			32,
			31,
			30,
			30,
			30,
			29,
			29,
			30,
			31,
			366
		]
	},
	16071: {
		year: 2043,
		month_days: [
			0,
			31,
			31,
			31,
			32,
			31,
			31,
			29,
			30,
			30,
			29,
			30,
			30,
			365
		]
	},
	16436: {
		year: 2044,
		month_days: [
			0,
			31,
			31,
			32,
			31,
			31,
			31,
			30,
			29,
			30,
			29,
			30,
			30,
			365
		]
	},
	16801: {
		year: 2045,
		month_days: [
			0,
			31,
			32,
			31,
			32,
			31,
			30,
			30,
			29,
			30,
			29,
			30,
			30,
			365
		]
	},
	17167: {
		year: 2046,
		month_days: [
			0,
			31,
			32,
			31,
			32,
			31,
			30,
			30,
			30,
			29,
			29,
			30,
			31,
			366
		]
	},
	17532: {
		year: 2047,
		month_days: [
			0,
			31,
			31,
			31,
			32,
			31,
			31,
			30,
			29,
			30,
			29,
			30,
			30,
			365
		]
	},
	17897: {
		year: 2048,
		month_days: [
			0,
			31,
			31,
			32,
			31,
			31,
			31,
			30,
			29,
			30,
			29,
			30,
			30,
			365
		]
	},
	18262: {
		year: 2049,
		month_days: [
			0,
			31,
			32,
			31,
			32,
			31,
			30,
			30,
			30,
			29,
			29,
			30,
			30,
			365
		]
	},
	18628: {
		year: 2050,
		month_days: [
			0,
			31,
			32,
			31,
			32,
			31,
			30,
			30,
			30,
			29,
			30,
			29,
			31,
			366
		]
	},
	18993: {
		year: 2051,
		month_days: [
			0,
			31,
			31,
			31,
			32,
			31,
			31,
			30,
			29,
			30,
			29,
			30,
			30,
			365
		]
	},
	19358: {
		year: 2052,
		month_days: [
			0,
			31,
			31,
			32,
			31,
			31,
			31,
			30,
			29,
			30,
			29,
			30,
			30,
			365
		]
	},
	19723: {
		year: 2053,
		month_days: [
			0,
			31,
			32,
			31,
			32,
			31,
			30,
			30,
			30,
			29,
			29,
			30,
			30,
			365
		]
	},
	20089: {
		year: 2054,
		month_days: [
			0,
			31,
			32,
			31,
			32,
			31,
			30,
			30,
			30,
			29,
			30,
			29,
			31,
			366
		]
	},
	20454: {
		year: 2055,
		month_days: [
			0,
			31,
			31,
			32,
			31,
			31,
			31,
			30,
			29,
			30,
			29,
			30,
			30,
			365
		]
	},
	20819: {
		year: 2056,
		month_days: [
			0,
			31,
			31,
			32,
			31,
			32,
			30,
			30,
			29,
			30,
			29,
			30,
			30,
			365
		]
	},
	21185: {
		year: 2057,
		month_days: [
			0,
			31,
			32,
			31,
			32,
			31,
			30,
			30,
			30,
			29,
			29,
			30,
			31,
			366
		]
	},
	21550: {
		year: 2058,
		month_days: [
			0,
			30,
			32,
			31,
			32,
			31,
			30,
			30,
			30,
			29,
			30,
			29,
			31,
			365
		]
	},
	21915: {
		year: 2059,
		month_days: [
			0,
			31,
			31,
			32,
			31,
			31,
			31,
			30,
			29,
			30,
			29,
			30,
			30,
			365
		]
	},
	22280: {
		year: 2060,
		month_days: [
			0,
			31,
			31,
			32,
			32,
			31,
			30,
			30,
			29,
			30,
			29,
			30,
			30,
			365
		]
	},
	22646: {
		year: 2061,
		month_days: [
			0,
			31,
			32,
			31,
			32,
			31,
			30,
			30,
			30,
			29,
			29,
			30,
			31,
			366
		]
	},
	23011: {
		year: 2062,
		month_days: [
			0,
			30,
			32,
			31,
			32,
			31,
			31,
			29,
			30,
			29,
			30,
			29,
			31,
			365
		]
	},
	23376: {
		year: 2063,
		month_days: [
			0,
			31,
			31,
			32,
			31,
			31,
			31,
			30,
			29,
			30,
			29,
			30,
			30,
			365
		]
	},
	23741: {
		year: 2064,
		month_days: [
			0,
			31,
			31,
			32,
			32,
			31,
			30,
			30,
			29,
			30,
			29,
			30,
			30,
			365
		]
	},
	24107: {
		year: 2065,
		month_days: [
			0,
			31,
			32,
			31,
			32,
			31,
			30,
			30,
			30,
			29,
			29,
			30,
			31,
			366
		]
	},
	24472: {
		year: 2066,
		month_days: [
			0,
			31,
			31,
			31,
			32,
			31,
			31,
			29,
			30,
			30,
			29,
			29,
			31,
			365
		]
	},
	24837: {
		year: 2067,
		month_days: [
			0,
			31,
			31,
			32,
			31,
			31,
			31,
			30,
			29,
			30,
			29,
			30,
			30,
			365
		]
	},
	25202: {
		year: 2068,
		month_days: [
			0,
			31,
			31,
			32,
			32,
			31,
			30,
			30,
			29,
			30,
			29,
			30,
			30,
			365
		]
	},
	25568: {
		year: 2069,
		month_days: [
			0,
			31,
			32,
			31,
			32,
			31,
			30,
			30,
			30,
			29,
			29,
			30,
			31,
			366
		]
	},
	25933: {
		year: 2070,
		month_days: [
			0,
			31,
			31,
			31,
			32,
			31,
			31,
			29,
			30,
			30,
			29,
			30,
			30,
			365
		]
	},
	26298: {
		year: 2071,
		month_days: [
			0,
			31,
			31,
			32,
			31,
			31,
			31,
			30,
			29,
			30,
			29,
			30,
			30,
			365
		]
	},
	26663: {
		year: 2072,
		month_days: [
			0,
			31,
			32,
			31,
			32,
			31,
			30,
			30,
			29,
			30,
			29,
			30,
			30,
			365
		]
	},
	27029: {
		year: 2073,
		month_days: [
			0,
			31,
			32,
			31,
			32,
			31,
			30,
			30,
			30,
			29,
			29,
			30,
			31,
			366
		]
	},
	27394: {
		year: 2074,
		month_days: [
			0,
			31,
			31,
			31,
			32,
			31,
			31,
			30,
			29,
			30,
			29,
			30,
			30,
			365
		]
	},
	27759: {
		year: 2075,
		month_days: [
			0,
			31,
			31,
			32,
			31,
			31,
			31,
			30,
			29,
			30,
			29,
			30,
			30,
			365
		]
	},
	28124: {
		year: 2076,
		month_days: [
			0,
			31,
			32,
			31,
			32,
			31,
			30,
			30,
			30,
			29,
			29,
			30,
			30,
			365
		]
	},
	28490: {
		year: 2077,
		month_days: [
			0,
			31,
			32,
			31,
			32,
			31,
			30,
			30,
			30,
			29,
			30,
			29,
			31,
			366
		]
	},
	28855: {
		year: 2078,
		month_days: [
			0,
			31,
			31,
			31,
			32,
			31,
			31,
			30,
			29,
			30,
			29,
			30,
			30,
			365
		]
	},
	29220: {
		year: 2079,
		month_days: [
			0,
			31,
			31,
			32,
			31,
			31,
			31,
			30,
			29,
			30,
			29,
			30,
			30,
			365
		]
	},
	29585: {
		year: 2080,
		month_days: [
			0,
			31,
			32,
			31,
			32,
			31,
			30,
			30,
			30,
			29,
			29,
			30,
			30,
			365
		]
	},
	29951: {
		year: 2081,
		month_days: [
			0,
			31,
			32,
			31,
			32,
			31,
			30,
			30,
			30,
			29,
			30,
			29,
			31,
			366
		]
	},
	30316: {
		year: 2082,
		month_days: [
			0,
			31,
			31,
			32,
			31,
			31,
			31,
			30,
			29,
			30,
			29,
			30,
			30,
			365
		]
	},
	30681: {
		year: 2083,
		month_days: [
			0,
			31,
			31,
			32,
			31,
			31,
			31,
			30,
			29,
			30,
			29,
			30,
			30,
			365
		]
	},
	31047: {
		year: 2084,
		month_days: [
			0,
			31,
			32,
			31,
			32,
			31,
			30,
			30,
			30,
			29,
			29,
			30,
			31,
			366
		]
	},
	31412: {
		year: 2085,
		month_days: [
			0,
			30,
			32,
			31,
			32,
			31,
			30,
			30,
			30,
			29,
			30,
			29,
			31,
			365
		]
	},
	31777: {
		year: 2086,
		month_days: [
			0,
			31,
			31,
			32,
			31,
			31,
			31,
			30,
			29,
			30,
			29,
			30,
			30,
			365
		]
	},
	32142: {
		year: 2087,
		month_days: [
			0,
			31,
			31,
			32,
			32,
			31,
			30,
			30,
			29,
			30,
			29,
			30,
			30,
			365
		]
	},
	32508: {
		year: 2088,
		month_days: [
			0,
			31,
			32,
			31,
			32,
			31,
			30,
			30,
			30,
			29,
			29,
			30,
			31,
			366
		]
	},
	32873: {
		year: 2089,
		month_days: [
			0,
			30,
			32,
			31,
			32,
			31,
			30,
			30,
			30,
			29,
			30,
			29,
			31,
			365
		]
	},
	33238: {
		year: 2090,
		month_days: [
			0,
			31,
			31,
			32,
			31,
			31,
			31,
			30,
			29,
			30,
			29,
			30,
			30,
			365
		]
	},
	33603: {
		year: 2091,
		month_days: [
			0,
			31,
			31,
			32,
			32,
			31,
			30,
			30,
			29,
			30,
			29,
			30,
			30,
			365
		]
	},
	33969: {
		year: 2092,
		month_days: [
			0,
			31,
			32,
			31,
			32,
			31,
			30,
			30,
			30,
			29,
			29,
			30,
			31,
			366
		]
	},
	34334: {
		year: 2093,
		month_days: [
			0,
			31,
			31,
			31,
			32,
			31,
			31,
			29,
			30,
			30,
			29,
			29,
			31,
			365
		]
	},
	34699: {
		year: 2094,
		month_days: [
			0,
			31,
			31,
			32,
			31,
			31,
			31,
			30,
			29,
			30,
			29,
			30,
			30,
			365
		]
	},
	35064: {
		year: 2095,
		month_days: [
			0,
			31,
			31,
			32,
			32,
			31,
			30,
			30,
			29,
			30,
			29,
			30,
			30,
			365
		]
	}
}, t = (t) => (typeof t == "string" && (t = parseInt(t)), Object.values(e).find((e) => e.year === t)?.month_days), n = (e, n) => (typeof e == "string" && (e = parseInt(e)), typeof n == "string" && (n = parseInt(n)), t(e)?.[n]), r = {
	dataset: e,
	queryMonthDays: t,
	queryDays: n
};
export { e as dataset, r as default, n as queryDays, t as queryMonthDays };

//# sourceMappingURL=look-up.js.map